/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from "@sentry/angular-ivy";

import { environment } from './environments/environment';
import packageJson from '../package.json';

Sentry.init({
  dsn: environment.sentry_dsn,
  environment: environment.sentry_environment,
  release: `snapmatic-frontend-v2@${packageJson.version}`,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [ /localhost/, /snapmatic.me/, /cloudfront.net/ ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
